<script setup lang="ts">
  import InputQC from '@qicgroupdoha/qic-connect-ds/components/InputQC'
  import { NAME_MAX_LENGTH } from '@/shared/constants/other.constants'
  import { LETTERS_AND_SPACES_MASK_CONFIG } from '../../VisitorForm.constants'

  interface Props {
    modelValue: string
    errors?: string[]
    isValid: boolean
    loading: boolean
  }

  const props = defineProps<Props>()
  const emit = defineEmits<{ (e: 'update:modelValue', value: string): void }>()

  const onBlur = () => {
    emit('update:modelValue', (props.modelValue ?? '').trim())
  }
</script>

<template>
  <InputQC
    :model-value="modelValue"
    :errors="errors"
    name="lastName"
    :label="$t('qic_user_name_family')"
    :max-length="NAME_MAX_LENGTH"
    :is-valid="isValid"
    :mask-config="LETTERS_AND_SPACES_MASK_CONFIG"
    :container-attrs="{ 'data-test': 'last-name-input' }"
    :loading="loading"
    data-test="last-name-input-inner"
    @update:model-value="$emit('update:modelValue', String($event ?? ''))"
    @blur="onBlur"
  />
</template>
